











































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { BIconX } from "bootstrap-vue";

@Component({ components: { BIconX } })
class AudioPlayerBar extends Vue {
  @Prop({ type: String, default: "" }) urlTemplate!: string;
  @Prop({ type: Object, default: () => ({}) })
  params!: Record<string, string | number>;
  @Prop({ type: String, default: "" }) title!: string;
  @Prop({ type: String, default: "" }) subtitle!: string;

  $refs!: {
    bar: HTMLElement;
    panel: HTMLElement;
    audio: HTMLAudioElement;
  };

  currentSrc = "";

  get hasParams(): boolean {
    return !!this.params && Object.keys(this.params).length > 0;
  }

  @Watch("urlTemplate")
  @Watch("params", { deep: true })
  rebuildSrc(): void {
    if (!this.urlTemplate || !this.hasParams) {
      this.currentSrc = "";
      return;
    }
    let url = this.urlTemplate;
    for (const key of Object.keys(this.params)) {
      const placeholder = `{${key}}`;
      const value = encodeURIComponent(String(this.params[key]));
      url = url.split(placeholder).join(value);
    }
    const token = this.$store.getters.getAccess;
    const sep = url.indexOf("?") > -1 ? "&" : "?";
    url = `${url}${sep}Authorization=Bearer ${token}`;
    this.currentSrc = url;
  }

  @Watch("currentSrc")
  onSrcChange(value: string): void {
    if (value) {
      this.$nextTick(() => {
        this.playAudio();
      });
    }
  }

  playAudio(): void {
    const audio = this.$refs.audio;
    if (audio) {
      audio.play().catch(() => undefined);
    }
  }

  mounted(): void {
    this.rebuildSrc();
    if (this.currentSrc) {
      this.$nextTick(() => {
        this.playAudio();
      });
    }
  }
}
export default AudioPlayerBar;
